<template>
  <div id="app">
    <Navbar id="navbar" />
    <router-view />
    <footer>
      AZORult Tracker - 2022 - version 1.1.0 -
      <a
        href="https://twitter.com/AZORult_Tracker"
        rel="noopener"
        target="_blank"
        >@AZORult_Tracker</a
      >
    </footer>
    <cookie-law theme="custom">
      <div slot-scope="props" class="message-box">
        <div class="message">
          <span class="icon">🦅</span> AZORult Tracker has been migrated to a
          smaller server, as a result several search features and API endpoints
          have been disabled. However, the main features are always active.
        </div>
        <b-button
          size="custom"
          class="my-2 my-sm-0"
          type="submit"
          @click="props.accept"
          >Got it!</b-button
        >
      </div>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import Navbar from "@/components/Navbar.vue";

export default {
  components: {
    CookieLaw,
    Navbar,
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "AZORult Tracker";
    },
  },
};
</script>

<style lang="scss" scoped>
#navbar {
  margin-bottom: 50px;
}
</style>

<style lang="scss">
.Cookie--custom {
  background: #443a3a;
  padding: 10px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.3);

  .message-box {
    display: flex;
    align-items: center;
    width: 100%;

    .message {
      flex: 1;
      color: #ccc;

      .icon {
        margin-right: 5px;
      }
    }
  }
}
</style>
